module.exports = __webpack_public_path__ + "img/Einzeldiagnose_Rechnung_Marie.89275daf.png";